import { useState } from "react";
const faqs = [
    {
        question: "How does an online vehicle inspection work?",
        answer: "After booking, you'll join a live video call with an inspector using your phone. Your inspector will guide you through the required inspection points and complete the inspection form based on the applicable requirements.",
    },
    {
        question: "Do you offer Uber, Lyft, and Turo vehicle inspections?",
        answer: "Yes. RideInspector offers vehicle inspections for Uber, Lyft, Turo, and other eligible rideshare and car-sharing platforms. Inspection availability and requirements may vary by platform and location."
    },
    {
        question: "What do I need for my inspection?",
        answer: "You'll need your vehicle, a smartphone with a working camera and internet connection, and access  o the areas of the vehicle that need to be inspected. Additional requirements may vary depending on the platform and inspection type."
    },
    {
        question: "How long does an online vehicle inspection take?",
        answer: "Most inspections can be completed in a short video session, although the exact time depends on the vehicle and inspection requirements."
    },
    {
        question: "Can I complete my Uber or Lyft vehicle inspection online?",
        answer: "Online inspection eligibility depends on the rideshare platform and the requirements in your location. RideInspector will help you determine whether your inspection can be completed remotely"
    },
    {
        question: "What happens after my inspection?",
        answer: "After your inspection is completed, the inspection form is reviewed and sent to you electronically"
    },
    {
        question: "What happens if my vehicle does not pass the inspection?",
        answer: "Your inspection form will reflect the vehicle's condition at the time of inspection. If an item does not meet the applicable requirements, you may need to correct the issue before the vehicle can qualify."
    },
    {
        question: "Is RideInspector affiliated with Uber, Lyft, or Turo?",
        answer: "No. RideInspector is an independent vehicle inspection service and is not affiliated with or endorsed by Uber, Lyft, or Turo."
    }

];

const FAQSection = () => {
    const [openIndex, setOpenIndex] = useState(0);

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="py-5 bg-light" >
            <div className="row justify-content-between align-items-center mb-4 mb-lg-5">
                <div className="col-lg-12 col-md-12 text-center">
                    <h2>Frequently Asked Questions</h2>
                </div>
            </div>

            <div className="container" >
                {faqs.map((faq, index) => {
                    const isOpen = openIndex === index;
                    return (
                        <div
                            key={index}
                            className="mb-3"
                            style={{
                                backgroundColor: "#ffffff",
                                borderRadius: "16px",
                                boxShadow: isOpen ? "0 2px 10px rgba(0,0,0,0.06)" : "none",
                                overflow: "hidden",
                            }}
                        >
                            <button
                                onClick={() => toggle(index)}
                                className="w-100 d-flex align-items-center border-0 bg-transparent text-start"
                                style={{ padding: "22px 24px", cursor: "pointer" }}
                            >
                                <span
                                    style={{
                                        fontSize: "1.05rem",
                                        fontWeight: 600,
                                        color: "#1a1a1a",
                                        flex: "1 1 auto",
                                    }}
                                >
                                    {faq.question}
                                </span>
                                <span
                                    style={{
                                        fontSize: "1.4rem",
                                        fontWeight: 400,
                                        color: "#1a1a1a",
                                        lineHeight: 1,
                                        marginLeft: "16px",
                                        flexShrink: 0,
                                    }}
                                    className="ms-auto"
                                >
                                    {isOpen ? "×" : "+"}
                                </span>
                            </button>

                            {isOpen && (
                                <div style={{ padding: "0 24px 22px 24px" }}>
                                    <p
                                        className="mb-0"
                                        style={{
                                            color: "#5f5f5f",
                                            fontSize: "0.95rem",
                                            lineHeight: 1.6,
                                        }}
                                    >
                                        {faq.answer}
                                    </p>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default FAQSection;